// extracted by mini-css-extract-plugin
export var abstractStandard_Headline = "standard-module--abstract-Standard_Headline--3ca44";
export var abstractStandard_Inner = "standard-module--abstract-Standard_Inner--bbdc6";